import { Page } from '@/core/architecture'

import { ResaleCreateCompletionTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ResaleCreateCompletion Page
 * Implemented as a practical sample.
 */
export const ResaleCreateCompletion: Page = () => {
  const { state, actions } = useViewModel()

  return <ResaleCreateCompletionTemplate state={state} {...actions} />
}
